import React, { useEffect, useState } from 'react';
import { startCase } from 'lodash';
import query from 'query-string';
import ReactPlayer from 'react-player';
import './style.scss';
import back from '../../assets/images/Back.png';
import professional from '../../assets/images/professional.png';
import calendar from '../../assets/images/Calendar.png';
import emptyView from '../../assets/images/EmptyView3x.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { AUTH_TOKEN, getStatusLabel, getStatusStyle } from '../../constants';
import axios from 'axios';
import { message } from 'antd';
import moment from 'moment';
import ReactGA from 'react-ga';
import { setEvent, setPageViewAnalytics } from '../../utils/analytics';

const Hitches = () => {
    let navigate = useNavigate();
    let location = useLocation();
    const [issueType, setIssueType] = useState(location && location.state && location.state.issueType ? location.state.issueType : ['OPEN', 'TO_BE_VERIFIED', 'RE_OPENED']);
    const [updated, updateList] = useState(false);
    const [baseData, setBaseData] = useState({});
    const [issueList, setIssueList] = useState([]);
    const [videoIdx, setVideoIdx] = useState(new Set());
    const [errorToast, setErrorToast] = useState(false);
    const [pageAnalytics, setPageAnalytics] = useState(false);
    const [loading, setLoading] = useState(false);
    const searchIssues = (payload) => {
        if (baseData && baseData.token) {
            axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/search`, payload, {
                headers: {
                    'Authorization': `Bearer ${baseData.token}`,
                },
                params: {
                    loadDetails:true
                },
            }).then(res => {
                setIssueList(res.data.responseData.data);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
                setErrorToast(true);
            });
        }
    }

    useEffect(() => {
        if(errorToast) {
            setTimeout(()=>setErrorToast(false), 1500);
        }
    },[errorToast]);
    
    useEffect(() => {
        setLoading(true);
        let qcData = baseData.qcId ? {
            refId: [(baseData.qcId || '')]
        }: {};
        if (baseData.crnId) {
            searchIssues({
                crnId: baseData.crnId,
                status: issueType,
                issueType: 'HITCH',
                ...qcData,
            });
        } else {
            setLoading(false);
        }
    }, [issueType, baseData]);

    useEffect(() => {
        setBaseData(query.parse(location.search));
    }, []);

    useEffect(() => {
        if (!pageAnalytics) {
            setPageViewAnalytics({ pageUrl: window.location.pathname, title: 'Issues Page' });
            setPageAnalytics(true);
        }
        setEvent({
            category: 'User',
            action: 'Prof_SE_Hitches',
            label: 'Prof_SE_Hitches',
            nonInteraction: true
        });
    },[baseData.token, pageAnalytics]);


    const getDays = (record) => {
        let startDate = moment(record.updatedAt);
        let endDate = moment();
        let diff = startDate.diff(endDate, 'days');

        return Math.abs(diff);
    }

    
    const isVideo = (url) => {
        if (url && typeof url === 'string'){
            let part = url.split('.');
            if(part[(part.length - 1)] === 'mp4'){
                return true;
            }
            else if(part[(part.length - 1)] === 'jpeg' || part[(part.length - 1)] === 'jpg' || part[(part.length - 1)] === 'png') {
                return false;
            }
        }
        else return null;
    }

    const isViewOnly = () => {
        if (baseData.viewOnly && baseData.viewOnly === 'true') {
            return true;
        }
        return false;
    }

    const getUpdatedByRole = (data) => {
        if (data.includes('BNB_CONTRACTOR')){
            return ' by Contractor';
        } else if (data.includes('BNB_SITE_ENGINEER')){
            return ' by SE';
        } else if (data.includes('BNB_PROJECT_MANAGER')){
            return 'by PM';
        } else {
            return '';
        }
    }
    // useEffect(() => {
    //     setIssueType(approvalStatus);
    // }, [approvalStatus]);
    return (
        <div className='background-div'>
            <div className='app-header'>
                <span onClick={()=>{
                        if (window.history.state.idx === 0) {
                            // eslint-disable-next-line no-undef
                            android.exitWebView();
                        } else {
                            navigate(-1)
                        }
                    }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '20px'}}>
                    <img src={back} height={25} width={15} />
                </span>
                <label style={{ flex: 2, justifyContent: 'flex-start' }}>Hitches</label>
            </div>
        <div className='issues-body'>
            <div className='issue-header'>
                <div className='header-tab' style={{color: issueType[0] === 'OPEN' ? '#F15A29' : '#6E7191'}} onClick={()=>setIssueType(['OPEN', 'TO_BE_VERIFIED', 'RE_OPENED'])}>Opened
                    {issueType[0] ==='OPEN' && <span className='active-vector'/>}
                </div>
                <div className='header-tab' style={{color: issueType[0] === 'CLOSED' ? '#F15A29' : '#6E7191'}} onClick={()=>setIssueType(['CLOSED', 'MISSED'])}>Closed
                    {issueType[0] ==='CLOSED' && <span className='active-vector'/>}
                </div>
                <div className='header-tab' style={{color: issueType[0] === 'MISSED_BY_CONTRACTOR' ? '#F15A29' : '#6E7191'}} onClick={()=>setIssueType(['MISSED_BY_CONTRACTOR'])}>Missed
                    {issueType[0] ==='MISSED_BY_CONTRACTOR' && <span className='active-vector'/>}</div>
                </div>
                <div className='issue-list'>
                {issueList.map((item, idx) => (
                        <div className='issue-card' style={{ flexDirection: 'column' }} onClick={() => navigate(`/issue-details${location.search}`, {
                            state: {
                                issueId: item.id,
                                issueType,
                                reverseUrl: '/hitches',
                            }
                        })}>
                            <span className='issue-status' style={getStatusStyle(item.status)}><label>{`${getStatusLabel(item.status).text}${item.status === 'MISSED' ? getUpdatedByRole(item.updatedByRole) : ''}${(item.status === 'OPEN' || item.status === 'RE_OPENED') && getDays(item) > 0 ? ` since ${getDays(item)} days` : ''}`}</label></span>
                            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
                                <div className='issue-img'>
                                {item && item.mediaUrls && isVideo(item.mediaUrls[0]) ? 
                                <div className='player-div' style={{ backgroundColor: 'black' }}>
                                    {videoIdx.has(idx) && 
                                    <div style={{position:'relative', zIndex: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}><div className="overlay-loader"></div></div>}
                                    <ReactPlayer 
                                        muted
                                        loop
                                        playing
                                        height={'100%'}
                                        width={'100%'}
                                        stopOnUnmount
                                        onBuffer={(data)=>{
                                            let idxs = new Set(videoIdx);
                                            idxs.add(idx);
                                            setVideoIdx(idxs);
                                        }}
                                        onBufferEnd={(data)=>{
                                            let idxs = new Set(videoIdx);
                                            idxs.delete(idx);
                                            setVideoIdx(idxs);
                                        }}
                                        style={{ position: 'absolute', top: 0, left:0}}
                                        url={item.mediaUrls[0]}
                                    />
                                </div>
                                // <video className='issue-img' width={'100%'} height={'100%'} controls autoPlay={false}>
                                //         <source src={item.mediaUrls[0]} type="video/mp4"/>
                                //     </video> 
                                    : item && item.mediaUrls && <img className='issue-img' src={item.mediaUrls[0]} width={'70px'} height={'71px'} />}
                                </div>
                                <div style={{ marginLeft: '5px' }}>
                                    <label className='issue-title'>{item.title}</label>
                                    <div className='issue-icon-row'>
                                        <span className='icon-titles'>
                                            <img src={professional} height={10} width={10} />
                                            {item.createdByName}
                                        </span>
                                        <span className='icon-titles'>
                                            <img src={calendar} height={10} width={10} />
                                            {moment(item.createdAt).format('DD MMM, YYYY')}
                                        </span>
                                    </div>
                                    <label className='issue-desc'>{item.description}</label>
                                </div>
                            </div>
                            <div className='snag-card-btn'>{(item.status === 'CLOSED' || item.status === 'MISSED' || item.status === 'MISSED_BY_CONTRACTOR') ? 'View Submission' : `${isViewOnly() ? 'View' : 'Update'} Hitch`}</div>
                        </div>
                    ))}
                    {!loading && issueList.length === 0 && <div className='empty-view'>
                        <img src={emptyView} className='empty-img' />
                        <span style={{ textAlign: 'center' }}>{baseData.crnId ? 'No Hitches available.' : 'Unknown error occurred, please connect with the team!'}</span>
                    </div>}
            </div>

            {loading && <div className='overlay-div'>
                <div className="overlay-loader"></div>
            </div>}

            {errorToast && <div className='overlay-div' style={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: 'transparent'}}>
                <label className='toast'>{'Something went wrong.'}</label>
            </div>}
            {baseData.role!=='BNB_CONTRACTOR' && (<div className='overlay-btn-grp'>
                <div onClick={() => {
                        // setViewDetails(false)
                        // createNewIssue();
                        navigate(`/create-hitch${location.search}`)
                    }} className='status-button' style={{ backgroundColor: '#F15A29', minHeight: '35px', minWidth: '150px', fontSize: '15px' }}>Create New Hitch</div>
            </div>)}
        </div>
        </div>
    )
};

export default Hitches;